import { Navigate, useParams } from 'react-router-dom';
import { isActivateAccountFunnelEnabled } from '@/config/branding';
import { ORG_ROUTES } from '@/config/router';

/** Redirects legacy org-scoped setup-payment URLs to the activation funnel. */
export function ActivateAccountRedirect() {
  const { orgSlug } = useParams<{ orgSlug: string }>();

  if (!orgSlug) {
    return <Navigate to="/setup-payment" replace />;
  }

  if (!isActivateAccountFunnelEnabled()) {
    return <Navigate to={ORG_ROUTES(orgSlug).BASE()} replace />;
  }

  return <Navigate to={ORG_ROUTES(orgSlug).ACTIVATE_ACCOUNT()} replace />;
}
